// packages/web/src/components/AgeQuestion.tsx — B1's own setup-age question
// ("Is {performerName} 18 or over?"), extracted so it has exactly ONE copy.
//
// B12 — before this chunk, Onboarding.tsx's own 'age' step was the only
// place this question was ever asked, and YourPage.tsx (B8/B9) mirrored its
// COPY without its markup: an account with no answer on file hit a dead-end
// refusal there, with nowhere to answer. Now both screens render THIS
// component, so the words and the two buttons cannot drift apart again the
// way YourPage.tsx's own duplicated refusal sentence already had (B12's
// walk, docs/beta-door/B12-your-page-asks-the-age.md).
//
// Deliberately a plain fragment, not its own `<div class="onb">`/`<div
// class="yp">` wrapper: the caller supplies that (and whatever eyebrow/dots
// come before it), because Onboarding.tsx and YourPage.tsx each lay out the
// rest of their own screen differently. What this component owns is only
// the part that must never drift: the question, the error, and the two
// required buttons — no "Skip for now" here, ever (B1: skipping would
// silently mean "minor").
import './AgeQuestion.css';

/** B12 — Onboarding.tsx's own failed-save sentence (unchanged copy, B1),
 * exported so YourPage.tsx's own in-place ask shows the exact same words on
 * a failed write rather than a close paraphrase. */
export const AGE_ANSWER_SAVE_FAILED_MESSAGE = 'Your answer didn’t save. Tap it again.';

export interface AgeQuestionProps {
  /** The performer's name, already trimmed — never "the performer": B1's
   *  own ruling is that the question names who it is about. */
  performerName: string;
  busy: boolean;
  /** Shown in place of nothing — never a second, vaguer copy of the real
   *  failure (F0's voice rule: failure is loud and named). */
  error: string | null;
  onAnswer: (isAdult: boolean) => void;
}

export function AgeQuestion({ performerName, busy, error, onAnswer }: AgeQuestionProps) {
  return (
    <>
      <div class="ageq__say" data-testid="ageq-question">
        Is {performerName} 18 or over?
      </div>
      {error ? (
        <div class="ageq__error" role="alert">
          {error}
        </div>
      ) : null}
      <div class="ageq__grow" />
      {/* Required — no skip. One tap, and skipping would silently mean
          "minor" (B1's own reasoning), so there is no "Skip for now"
          affordance here, unlike most steps around this component. */}
      <button
        type="button"
        class="ageq__btn"
        disabled={busy}
        data-testid="ageq-yes"
        onClick={() => onAnswer(true)}
      >
        Yes, 18 or over
      </button>
      <button
        type="button"
        class="ageq__btn ageq__btn--secondary"
        disabled={busy}
        data-testid="ageq-no"
        onClick={() => onAnswer(false)}
      >
        No, under 18
      </button>
    </>
  );
}
